import { useEffect, useState } from "react"
import { motion } from "framer-motion"
import { Twitter, Mail } from "lucide-react"
import { FaLinkedinIn, FaTiktok } from "react-icons/fa"

export default function SocialMediaIcons() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  const socialIcons = [
    // { icon: <Twitter size={20} />, href: "#", label: "Twitter" },
    // { icon: <FaTiktok size={20} />, href: "#", label: "TikTok" },
    { icon: <FaLinkedinIn size={20} />, href: "#", label: "LinkedIn" },
    { icon: <Mail size={20} />, href: "#", label: "Email" },
  ]

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 260,
        damping: 20,
      },
    },
  }

  return (
    <div className="flex items-center justify-center mt-6">
      <motion.div className="flex space-x-4" variants={container} initial="hidden" animate="show">
        {socialIcons.map((social, index) => (
          <motion.a
            key={index}
            href={social.href}
            aria-label={social.label}
            className="flex items-center justify-center w-10 h-10 bg-black rounded-full text-white hover:bg-gray-800 transition-colors"
            variants={item}
            whileHover={{
              scale: 1.2,
              rotate: [0, -10, 10, -10, 0],
              transition: { duration: 0.5 },
            }}
            whileTap={{ scale: 0.9 }}
          >
            {social.icon}
          </motion.a>
        ))}
      </motion.div>
    </div>
  )
}
